import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../api-client.config';

interface FixtureScoresResponse {
  success: boolean;
  fixture: {
    externalId: string;
    leagueId: string;
    status: 'scheduled' | 'live' | 'finished' | 'postponed' | 'cancelled';
    clock: string;
    quarter: number | null;
    homeScore: number | null;
    awayScore: number | null;
    homeTeam: {
      id: string;
      name: string;
      abbreviation: string | null;
      logoUrl: string | null;
    } | null;
    awayTeam: {
      id: string;
      name: string;
      abbreviation: string | null;
      logoUrl: string | null;
    } | null;
    scheduledDate: string;
    periodScores?: Array<{
      periodNumber: number;
      periodType: 'quarter' | 'period' | 'half' | 'overtime';
      homeScore: number;
      awayScore: number;
    }>;
  };
}

export const getFixtureScores = async (squareId: string): Promise<FixtureScoresResponse> => {
  const response = await (apiClient as any).get(`/api/admin/squares/${squareId}/fixture-scores`);
  return response as FixtureScoresResponse;
};

export const useGetFixtureScoresQuery = (squareId: string | null) => {
  return useQuery({
    queryKey: ['squares', 'fixture-scores', squareId],
    queryFn: () => getFixtureScores(squareId!),
    enabled: !!squareId,
    // Poll every 5s when live so scoreboard can see quarter/period updates; 10s otherwise
    refetchInterval: query => (query.state.data?.fixture?.status === 'live' ? 5000 : 10000),
  });
};
